/**
 * Top-tier medical device standards that should appear first
 * within each group (selected / unselected) when listing ISOs.
 * Ordered by priority.
 */
export const PRIORITY_STANDARD_IDS = new Set([
    'iso-13485', // Quality management systems for medical devices
    'iso-14971', // Risk management
    'iso-10993-1', // Biocompatibility — Evaluation and testing within a risk management process
    'iso-11607-1', // Packaging for terminally sterilized medical devices — Part 1
    'iso-11607-2', // Packaging for terminally sterilized medical devices — Part 2
    'iso-15223-1', // Symbols for medical device labelling
    'iso-11135', // Sterilization by ethylene oxide
    'iec-60601-1', // Medical electrical equipment — General requirements for basic safety and essential performance
]);
//# sourceMappingURL=priority-standards.js.map